export function divideQueryParams(params) {
  return new URLSearchParams(params);
}
